import React, {useEffect, useMemo, useState, useRef, useContext} from 'react';
import Input from "../../master/Input";
import SearchablePicker from "../../master/SearchablePicker";
import DatePicker from "../../master/DatePicker";
import ExpertImage from "../ExpertImage";
import {getDirection, pexios, toast, validate} from "../../../utils/functions";
import { latinAlphabet } from "../../../utils/variables";
import { useTranslation } from 'react-i18next';
import { TitleContext } from '../../../App';

export default function ThirdData({ data, changeData, uploadImage, changeStep, userType = 'culprit', lossesIndex = 0 }) {

    const form = useRef(null);
    const imageForm = useRef(null);
    const { t, i18n } = useTranslation();
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);

    const title = useMemo(() => userType === 'culprit' ? t('Culprit') : `${t('Losses')} ${t(latinAlphabet[lossesIndex])}`, [lossesIndex, userType]);
    const imageSuffix = useMemo(() => userType === 'losses' ? (lossesIndex + 1) : '', [lossesIndex, userType]);
    // const {setTitle} = useContext(TitleContext)
    // useEffect(()=>{
    //     setTitle(`${t('Third insurance info')} ${title}`)
    // },[])
    useEffect(() => {
        pexios('api/v2/get_insurance')
            .then(res => {
                setInsuranceCompanies(res.data.data);
            });
    }, []);


    function nextStep() {
        const error = validate(form) + (validate(form) && validate(imageForm) && '،') + validate(imageForm);
        if (error) {
            // toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            toast(t('Complete required fields',{err:error}), 'error');
            return;
        }
        changeStep(data.insurance_type === 'body' ? 3 : 4);
    }

    return (
        <>
            <h4 className='mt20 border-title title-text'>{`${t('Third insurance info')} ${title}`}</h4>
            <div className={`row ${getDirection(i18n.language) ==='rightToLeft'? 'text-right':'text-left'}`} ref={form}>
                <Input
                    label={`${t('Insurer fullname')} ${t('Third only')}`}
                    value={data.third.insurance_owner_name}
                    required
                    onChange={value => changeData(value, 'insurance_owner_name', 'third')}
                />
                <Input
                    label={`${t('Insurer national id')} ${t('Third only')}`}
                    value={data.third.insurance_owner_national_id}
                    maxLength={10}
                    mode='numeric'
                    name='nationalId'
                    required
                    onChange={value => changeData(value, 'insurance_owner_national_id', 'third')}
                />
                <Input
                    label={t('Third insurance number')}
                    value={data.third.insurance_number}
                    required
                    onChange={value => changeData(value, 'insurance_number', 'third')}
                />
                <SearchablePicker
                    label={t('Third insurance company')}
                    value={data.third.insurance_company || ''}
                    data={insuranceCompanies}
                    rtl={getDirection(i18n.language) ==='rightToLeft'}
                    titleKey='title'
                    valueKey='id'
                    required
                    onSelect={val => changeData(val, 'insurance_company', 'third')}
                    disabled={data.insurance_type === 'third' && userType === 'culprit'}
                    hasIcon
                />
                <DatePicker
                    label={t('Third insurance start date')}
                    value={data.third.insurance_start_date}
                    required
                    onChange={date => changeData(date, 'insurance_start_date', 'third')}
                    isInsuranceDate
                />
                <DatePicker
                    label={t('Third insurance end date')}
                    value={data.third.insurance_expire_date}
                    required
                    onChange={date => changeData(date, 'insurance_expire_date', 'third')}
                    isInsuranceDate
                />
            </div>
            <div className='gridParent' ref={imageForm}>
                <ExpertImage
                    title={t('Third insurance image')}
                    src={data.attachments.filter(itm => itm.filename.includes(`${userType}_third_image${imageSuffix}`))}
                    upload={(img, done) => uploadImage(img, `expert_${userType}_third_image${imageSuffix}`, done)}
                    label='third_image'
                    // required={!((userType === 'culprit' && data.insurance_type === 'third' && data.has_coroukie === 1) || (userType === 'culprit' && data.insurance_type === 'body'))}
                />
            </div>
            <div className='d-flex mt20 pr5 pl5'>
                <button
                    onClick={() => changeStep(1)}
                    className='btn btn-orange btn-block btn-circle-left'
                >
                   {t('Prev step')}
                </button>
                <button
                    onClick={nextStep}
                    className='btn btn-white-purple btn-block btn-circle-right'
                >
                    {t('Next step')}
                </button>
            </div>
        </>
    );
}
